import { getPromisifiedActionsResults } from './store/promisified-actions-selectors';

export function createPromisifiedActionsService() {
  const correlationIdToPromise: Record<string, any> = {};

  function usePromisifiedAction(action: any, state: any) {
    resolvePromisifiedActions(state);

    return (...args: any[]) => {
      return new Promise((resolve, reject) => {
        const correlationId = Date.now() + parseFloat(Math.random().toFixed(2)) * 100;
        correlationIdToPromise[correlationId] = { resolve, reject };
        action(args, correlationId);
      });
    };
  }

  function resolvePromisifiedActions(state: any) {
    const results = getPromisifiedActionsResults(state);
    Object.entries(results).forEach(([correlationId, { payload, isResolved }]: [string, any]) => {
      const p = correlationIdToPromise[correlationId];
      if (p) {
        if (isResolved) {
          p.resolve(payload);
        } else {
          p.reject(payload);
        }
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete correlationIdToPromise[correlationId];
      }
    });
  }

  return { usePromisifiedAction, resolvePromisifiedActions };
}
